import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { OrdersCoServices } from "../../services";
import { Globals } from "../../../../globals";
import { ConfigurationRoomsCreateTablePage } from "../../../configuration/configuration-rooms/configuration-rooms-create/configuration-rooms-create-table/configuration-rooms-create-table";
import { OrdersTablePage } from '../../orders-table/orders-table';
import { HomePage } from '../../../home/home';
import { BlockScreenPage } from '../../../components/block-screen/block-screen';
import { TPVServices } from '../../../tpv/services';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { PopupNewAppsPage } from '../../../components/popups/popup-new-apps/popup-new-apps';

/**
 * Generated class for the OrdersSelectRoomPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-orders-select-room',
  templateUrl: 'orders-select-room.html',
})
export class OrdersSelectRoomPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public ordersCoServices: OrdersCoServices,
    public globals: Globals,
    public loadingCtrl: LoadingController,
    public tpvServices: TPVServices) {
  }

  ionViewDidLoad() {
  }

  disableTable(uid_room) {
    let styles;
    if (uid_room != this.ordersCoServices.room_selected_uid || !uid_room) {
      styles = {
        'display': 'none'
      };
    } else {
      styles = {
        'display': 'grid'
      };
    }
    return styles;
  }

  disableTableXs(uid_room) {
    let styles;
    if (uid_room != this.ordersCoServices.room_selected_uid || !uid_room) {
      styles = {
        'display': 'none'
      };
    } else {
      styles = {
        'display': 'flex'
      };
    }
    return styles;
  }

  openTicket(index, type, value) {
    //loadingPopup
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    //select index of table
    this.ordersCoServices.selected_table_tpv = value;
    this.ordersCoServices.selected_table_tpv_index = index;
    this.ordersCoServices.selected_type = 'table';
    //recuperar de tpvservices el index de la mesa
    var index_tpv_array = this.tpvServices.tables_array.findIndex(table => table.UID === this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].UID);
    this.tpvServices.selected_table_tpv_index = index_tpv_array;
    this.tpvServices.selected_type = 'table';
    //check if table to check funcion room exists
    if (this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].type != 'bar') {
      this.tpvServices.getIfRoom();
    }
    //push
    this.navCtrl.push(OrdersTablePage, {
      table: value,
    });

    loadingPopup.dismiss();
  }

  createTable(room_uid, room_name) {
    this.navCtrl.push(ConfigurationRoomsCreateTablePage, {
      room_uid: room_uid,
      room_name: room_name,
      update: false,
    });
  }

  close() {
    this.globals.side_menu_active = 'dashboard';
    this.navCtrl.setRoot(HomePage);
  }

  block() {
    this.navCtrl.push(BlockScreenPage, {
      type: 'orders',
    });
  }

  limitCharsClass(table) {
    let cssClasses = {};
    if (table.map_style) {
      cssClasses = {
        'limitCharsRooms-square': table.map_style === 'dnd-square',
        'limitCharsRooms-circle': table.map_style === 'dnd-circle',
        'limitCharsRooms-rectangle': table.map_style === 'dnd-rectangle',
        'limitCharsRooms-rectangle-vertical': table.map_style === 'dnd-rectangle-vertical',
        'limitCharsRooms-circle-big': table.map_style === 'dnd-circle-big',
        'limitCharsRooms-rectangle-big': table.map_style === 'dnd-rectangle-big',
        'limitCharsRooms-rectangle-big-vertical': table.map_style === 'dnd-rectangle-big-vertical',
      }
    } else {
      cssClasses = {
        'limitCharsRooms-square': 'dnd-square',
      }
    }
    return cssClasses;
  }
  //
  tableStyle(table) {

    if (!table.map_top) {
      table.map_top = 0;
    }
    if (!table.map_left) {
      table.map_left = 0;
    }
    let style = {
      'top': table.map_top + 'px',
      'left': table.map_left + 'px',
      'position': 'absolute',
    }

    if (table.uid_room != this.ordersCoServices.room_selected_uid || !table.uid_room) {
      style['display'] = 'none';
    }

    return style;
  }
  //
  tableClass(table) {
    if (table.map_style) {
      let cssClasses = {
        'tpv-table-green': table.state === 'open',
        'tpv-table-yellow': table.state === 'ticket',
        'tpv-table-red': table.state === 'close',
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'tpv-table-green': table.state === 'open',
        'tpv-table-yellow': table.state === 'ticket',
        'tpv-table-red': table.state === 'close',
        'dnd-square': true,
      }
      return cssClasses;
    }
  }

  openTakeaway() {
    if (this.globals.checkLimitsByLicense('tpv', 'takeaway')) {
      this.globals.mobile_is_room = false;
      this.tpvServices.menu_select_room = 'take_away';
      this.globals.side_menu_active = 'tpv';
      //this.navCtrl.setRoot(TpvLoaderPage);
      this.navCtrl.push(PopupNewAppsPage, { app: 'pos' });
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/orders/orders-rooms/orders-select-room/orders-select-room.ts